import React from 'react';
import "./Nftshowcase.css"
import logo1 from "./logo1.png"
import logo2 from "./logo2.png"
import logo3 from "./logo3.png"
import logo4 from "./logo4.png"
import ShareButton from './sharebutton';

const JacekShowcase = () => {
  return (
    <div className="showcase-container">
      <div className="showcase-item">
        <h2>BABY JECAK</h2>
        <img src={logo1} alt="BABY JACEK" className="showcase-image" />
        <p className="showcase-description">Eyes wide open, BABY JACEK, your new favorite internet hedgehod is born. Get ready to break the Internet with BABY JACEK. </p>
        <ShareButton message="Check out BABY JACEK, the internet's new favorite hedgehog! I am #BabyJECAK which one are you? https://jacek.club" />

        <p >NFTs Dropping Soon...</p>
      </div>
      <div className="showcase-item">
      <h2>NERD JECAK</h2>
        <img src={logo2} alt="JACEK the NERD" className="showcase-image" />
        <p className="showcase-description">Shades on, Nerd JECAK, master creator of the digital realm, crafts worlds within worlds. 
        He codes, he curates, he conquers the infinite web.</p>
        <ShareButton message="I am a #NerdJECAK. Which one are you? #JECAK https://jacek.club" />
        <p>NFTs Dropping Soon...</p>
      </div>
      <div className="showcase-item">
      <h2>COOL JECAK</h2>
        <img src={logo3} alt="JACEK the SURGER" className="showcase-image" />
        <p className="showcase-description">Cap flipped back and hands in pockets, Cool JECAK surfs the Web3, taking profits along the way. Get
         ready to chill and break internet trends with Cool JECAK. </p>
         <ShareButton message="Hats on. Creating and Trading. I am #CoolJECAK. Which one are you? https://jecak.club " />
         <p>NFTs Dropping Soon...</p>
      </div>
      <div className="showcase-item">
      <h2>BADASS JECAK</h2>
        <img src={logo4} alt="JACEK the BADASS" className="showcase-image" />
        <p>In the digital shadows, Badass JECAK, the DEGEN, wields the power to disrupt and destroy. Fighting for the underdog, this rebel challenges the digital order. Rise with Badass JECAK, disrupt, conquer the system.
</p>
<ShareButton message = "I wish I was #BadassJECAK. Which one are you https://jacek.club"/>
<p classname = "coming-soon">NFTs Dropping Soon...</p>
      </div>
    </div>
  );
};

export default JacekShowcase;
